export const campaignTable = (data) => {
    return data && data.length && data.map((item, index) => {
        const {
            campaign_id,
            account_id,
            campaign_name,
            account_name,
            campaign_status,
            clicks,
            blocks,
            budged_saved,
        } = item;

        return {
            rowId: index + 1,
            campaign_id,
            campaign_name,
            account_name,
            campaign_status,
            clicks,
            blocks,
            budged_saved,
        };
    });
}

export const campaigngraphData = () => {
    return [
        {
            name: "Some Data", chartType: 'line',
            values: [25, 40, 30, 35, 8, 52, 17, -4]
        },
        {
            name: "Another Set", chartType: 'line',
            values: [25, 50, -10, 15, 18, 32, 27, 14]
        },
        {
            name: "Yet Another", chartType: 'line',
            values: [15, 20, -3, -15, 58, 12, -17, 37]
        },
    ];
};
